
import MagicStar from "../../../assets/duotone/MagicStar.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MagicStarIcon({ className, dataTestid = "MagicStarIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MagicStar data-testid={dataTestid} className={classes} {...rest} />
  );
}
